import { useAuthStore, usePrefsStore } from '../lib/stores.js';
import { timezoneForCountry } from '../lib/time.js';

// Resolves the IANA timezone EPG times should render in:
//   1. user-picked timezone (TopBar dropdown / vibe-prefs)
//   2. timezone of the signed-in user's country (HU → Europe/Budapest)
//   3. null → formatTime falls back to the browser zone
// Components should call this and pass the result straight to formatTime.
export function useTimezone() {
  const explicit = usePrefsStore((s) => s.timezone);
  const country = useAuthStore((s) => s.user?.country);
  return explicit || timezoneForCountry(country) || null;
}
